import fallbackPhoto from "../assets/img/dummy_profile.png";

export const resolvePhotoUrl = (photo, fallback = fallbackPhoto) => {
  if (typeof photo !== "string" || !photo.trim() || ["null", "undefined", "string"].includes(photo.trim())) return fallback;
  const path = photo.trim();
  if (/^(https?:|blob:|data:|\/\/)/i.test(path) || path.startsWith("/static/")) return path;
  const base = (process.env.REACT_APP_API_URL || "https://iptestapi.irbureau.com").replace(/\/+$/, "");
  return `${base}/${path.replace(/^\/+/, "")}`;
};

export const surveyPhoto = (survey) => resolvePhotoUrl(
  survey?.author?.profile_photo || survey?.author?.avatar || survey?.author_avatar || survey?.profile_photo
);

export const handlePhotoError = (event) => {
  if (event.currentTarget.getAttribute("src") !== fallbackPhoto) {
    event.currentTarget.src = fallbackPhoto;
  }
};
